/** angular */
import { Injectable } from '@angular/core';
import { BydGenerateParams } from '@sixense/byd-core-service';
import { Observable } from 'rxjs';
/** end angular */

/** services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** end services */

/**
 * Service to retrieve every photos of a form instance.
 */
@Injectable({
  providedIn: 'root',
})
export class DsFormInstancePhotosService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get a zip that contains all the form instance photos.
   *
   * @param projectId The project id.
   * @param instanceId The instance id.
   * @param reportName Report name.
   * @returns Observable<Blob>
   */
  public getPhotosZip(projectId: number, instanceId: number, reportName: string): Observable<Blob> {
    const params = BydGenerateParams({ reportName });
    this.path = `/v1/dsform/projects/${projectId}/instances/${instanceId}/photos`;
    return this.get<Blob>({ params, responseType: 'blob' });
  }

  /**
   * No use for now but necessary for BydRhsAbstractService.
   */
  public createNewInstance() {}
}
